import { RecoveryPasswordRequestPage } from '$pages/auth/recovery-password/recovery-password-request/recovery-password-request';
import { LoginProvider } from '$providers/login';
import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { Events, NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  user = { cpf: "", password: "" };

  autoLogin = true;

  constructor(private navCtrl: NavController, private navParams: NavParams, private events: Events, private viewProvider: ViewProvider,
    private loginProvider: LoginProvider) {
    if (this.loginProvider.get())
      this.user.cpf = this.loginProvider.get().cpf;
  }

  ionViewWillEnter() {
    if (this.navParams.get('cpf')) {
      this.user.cpf = this.navParams.get('cpf');
    }
  }

  public validate(): boolean {
    var valido = true;
    var msg = "";

    if (this.user.cpf.length <= 0) {
      valido = false;
      msg = "Informe o <b>CPF</b>.<br>";
    }

    if (this.user.password.length <= 0) {
      valido = false;
      msg = msg + "Informe a <b>Senha</b>.";
    }

    if (!valido) {
      this.viewProvider.showWarn(msg);
    }

    return valido;
  }

  public submit() {
    if (!this.validate()) {
      return;
    }

    this.events.publish('login:submit', this.user, this.autoLogin);
  }

  public requestPasswordRecovery() {
    this.navCtrl.push(RecoveryPasswordRequestPage, { cpf: this.user.cpf });
  }

  public setFocus(componente) {
    componente.setFocus();
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/login/login.ts